import { gql } from '@apollo/client'

import { USER_DETAILS_FRAGMENT } from '../fragments'

const USER_QUERY = gql`
  query user($id: ID!) {
    user(id: $id) {
      ...UserDetailsFragment
    }
  }
  ${USER_DETAILS_FRAGMENT}
`

export default USER_QUERY
